import { useEffect, useState } from 'react';
import oktaAuth from '../auth/oktaAuth';

// Dedicated route matching oktaAuth's redirectUri. handleRedirect() exchanges
// the auth code for tokens, stores them, then redirects back to the
// originalUri set by signInWithRedirect (defaults to window.location.replace).
function LoginCallback() {
  const [error, setError] = useState(null);

  useEffect(() => {
    oktaAuth.handleRedirect().catch((err) => {
      setError(err.message || 'Login failed');
    });
  }, []);

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        Login failed: {error}. <a href="/login">Try again</a>
      </div>
    );
  }

  return null;
}

export default LoginCallback;
